(() => {
  const script = document.currentScript || document.querySelector('script[data-matheria-free-gift]');
  if (!script || window.MatheriaFreeGift) return;

  const giftVariantId = Number(script.dataset.variantId);
  if (!Number.isInteger(giftVariantId)) return;

  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sectionNames = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'main-cart-footer'];
  let syncing = false;
  let syncTimer;
  let syncRequested = false;

  const request = async (path, body) => {
    const options = body
      ? {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      : { headers: { Accept: 'application/json' } };

    const response = await fetch(routeRoot + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed');
    return data;
  };

  const mutationPayload = (extra) =>
    Object.assign(
      {
        sections: sectionNames,
        sections_url: window.location.pathname,
      },
      extra
    );

  const replaceSection = (html, selector) => {
    if (!html) return false;
    const current = document.querySelector(selector);
    const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!current || !replacement) return false;
    current.innerHTML = replacement.innerHTML;
    return true;
  };

  const renderCart = (state) => {
    if (!state || !state.sections) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state.sections['cart-drawer']) {
      drawer.renderContents(state);
    }

    replaceSection(state.sections['cart-icon-bubble'], '#cart-icon-bubble');
    replaceSection(state.sections['cart-live-region-text'], '#cart-live-region-text');
    replaceSection(state.sections['main-cart-items'], '#main-cart-items .js-contents');
    replaceSection(state.sections['main-cart-footer'], '#main-cart-footer .js-contents');
  };

  const showGiftDialog = () => {
    if (document.getElementById('MatheriaGiftDialog')) return;

    const dialog = document.createElement('dialog');
    dialog.id = 'MatheriaGiftDialog';
    dialog.setAttribute('aria-labelledby', 'MatheriaGiftDialogTitle');
    dialog.style.cssText =
      'max-width:min(90vw,42rem);padding:2.4rem 4.8rem 2.4rem 2.4rem;border:0;border-radius:1rem;box-shadow:0 1rem 4rem rgba(0,0,0,.22);color:rgb(var(--color-foreground));background:rgb(var(--color-background));';

    const close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', script.dataset.closeLabel || 'Chiudi');
    close.textContent = '×';
    close.style.cssText =
      'position:absolute;top:.8rem;right:1.2rem;border:0;background:transparent;font-size:3rem;line-height:1;cursor:pointer;color:inherit;';

    const title = document.createElement('h2');
    title.id = 'MatheriaGiftDialogTitle';
    title.textContent = script.dataset.title || 'Un omaggio MATHERIA per te';
    title.style.margin = '0 0 1rem';

    const message = document.createElement('p');
    message.textContent = script.dataset.message || 'Abbiamo aggiunto il portagioie MATHERIA al tuo carrello.';
    message.style.margin = '0';

    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => dialog.remove(), { once: true });
    dialog.append(close, title, message);
    document.body.appendChild(dialog);

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  const publishUpdate = (cartData) => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'matheria-free-gift',
        cartData,
      });
    }
  };

  const syncCart = async () => {
    if (syncing) {
      syncRequested = true;
      return;
    }
    syncing = true;
    syncRequested = false;

    try {
      const cart = await request('cart.js');
      const giftLines = cart.items.filter((item) => Number(item.variant_id) === giftVariantId);
      const hasQualifyingProduct = cart.items.some((item) => Number(item.variant_id) !== giftVariantId);
      let state;

      if (hasQualifyingProduct && giftLines.length === 0) {
        state = await request(
          'cart/add.js',
          mutationPayload({
            items: [
              {
                id: giftVariantId,
                quantity: 1,
                properties: { _matheria_free_gift: 'true' },
              },
            ],
          })
        );
        renderCart(state);
        showGiftDialog();
        publishUpdate(state);
        return;
      }

      if (!hasQualifyingProduct && giftLines.length > 0) {
        const updates = {};
        giftLines.forEach((item) => {
          updates[item.key] = 0;
        });
        state = await request('cart/update.js', mutationPayload({ updates }));
        if (state.item_count === 0 && window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
          window.location.reload();
          return;
        }
        renderCart(state);
        publishUpdate(state);
        return;
      }

      if (hasQualifyingProduct && giftLines.length > 0) {
        const updates = {};
        giftLines.forEach((item, index) => {
          updates[item.key] = index === 0 ? 1 : 0;
        });
        const needsCorrection = giftLines.length > 1 || giftLines[0].quantity !== 1;
        if (needsCorrection) {
          state = await request('cart/update.js', mutationPayload({ updates }));
          renderCart(state);
          publishUpdate(state);
        }
      }
    } catch (error) {
      console.error('[MATHERIA free gift]', error);
    } finally {
      syncing = false;
      if (syncRequested) scheduleSync();
    }
  };

  const scheduleSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCart, 120);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  else scheduleSync();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source !== 'matheria-free-gift') scheduleSync();
    });
  }

  document.addEventListener('shopify:section:load', scheduleSync);
  window.MatheriaFreeGift = { sync: scheduleSync };
})();
